import { styled } from "@mui/system";
export const ReferenceCreateInputContainer = styled("div") `
    position: relative;
    padding-left: 98px;
    width: calc(100% - 98px);
`;
